import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}/sales-order-requisition-config`;

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getAuthToken()}`,
});

export const fetchSalesOrderRequisitionConfigs = async () => {
  const response = await axiosInstance.get(`${API_URL}/list`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const fetchSalesOrderRequisitionConfigById = async (id: string) => {
  const response = await axiosInstance.get(`${API_URL}/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const fetchSalesOrderRequisitionConfigByCompanyCode = async (
  companyCode: string
) => {
  const response = await axiosInstance.get(
    `${API_URL}/get-sales-order-requistion-config?companyCode=${companyCode}`,
    { headers: authHeaders() }
  );
  return response.data;
};

export const addSalesOrderRequisitionConfig = async (data: any) => {
  const response = await axiosInstance.post(`${API_URL}/create`, data, {
    headers: authHeaders(),
  });
  return response.data;
};

export const updateSalesOrderRequisitionConfig = async (
  id: string,
  data: any
) => {
  const response = await axiosInstance.put(`${API_URL}/update/${id}`, data, {
    headers: authHeaders(),
  });
  return response.data;
};

export const removeSalesOrderRequisitionConfig = async (id: string) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};
